import type { Observable } from 'rxjs';
import httpService from './httpService';
import type { TripLeg, TripLegID } from '../data/models/trip-leg.model';
import type { Invoices, InvoiceDetails } from '../data/models/invoice.model';

class InvoiceService {
  private readonly apiBase;
  constructor() {
    const { __environment__ } = window as unknown as {
      __environment__: { REACT_APP_PUBLIC_ACCOUNTING_API_URL: string };
    };
    this.apiBase = __environment__.REACT_APP_PUBLIC_ACCOUNTING_API_URL.trim();
  }

  public generateInvoice(
    transportationProviderID: number,
    lineItems: TripLegID[],
  ): Observable<TripLeg> {
    const url = `${this.apiBase}/provider-invoice`;
    return httpService.postJSON(url, { transportationProviderID, lineItems });
  }

  public getInvoices(transportationProviderID: number): Observable<Invoices> {
    const url = `${this.apiBase}/provider-invoice?transportationProviderID=${transportationProviderID}`;
    return httpService.getJSON(url);
  }

  public getInvoiceDetails(
    providerInvoiceID: number,
  ): Observable<InvoiceDetails> {
    const url = `${this.apiBase}/attested-trip-legs/${providerInvoiceID}`;
    return httpService.getJSON(url);
  }

  public generateInvoicePDF(
    providerInvoiceID: number,
    timezoneOffset: number,
  ): Observable<ArrayBuffer> {
    const url = `${this.apiBase}/provider-invoice/${providerInvoiceID}/generate-pdf?timezoneOffset=${timezoneOffset}`;
    return httpService.postJSON(url, {}, true, 'arraybuffer');
  }
}

const invoiceService = new InvoiceService();

export default invoiceService;
